import React from "react";
import { AlertTriangle, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";

const fmt = (n) => (n ?? 0).toLocaleString("it-IT");

export default function LowBalanceBanner({ user, onBuy }) {
  if (!user || user.unlimited) return null;

  const subscribed = user.sub_status === "active";
  const subChars = user.sub_chars ?? 0;
  const subLimit = user.sub_limit ?? 0;
  const topup = user.topup_chars ?? 0;
  const topupTotal = user.topup_total ?? 0;
  const remaining = subChars + topup;

  const denom = subscribed ? (subLimit || 1) : (topupTotal || Math.max(topup, 1));
  const low = remaining <= denom * 0.1;
  const empty = remaining <= 0;

  if (!low) return null;

  return (
    <div
      data-testid="low-balance-banner"
      className={`mb-6 flex flex-col sm:flex-row sm:items-center gap-3 rounded-2xl border px-4 py-3 ${
        empty ? "border-destructive/40 bg-destructive/10" : "border-amber-500/40 bg-amber-500/10"
      }`}
    >
      <div className="flex items-start gap-3 flex-1">
        <AlertTriangle className={`h-5 w-5 shrink-0 mt-0.5 ${empty ? "text-destructive" : "text-amber-500"}`} />
        <div>
          <p className={`text-sm font-semibold ${empty ? "text-destructive" : "text-amber-600 dark:text-amber-400"}`}>
            {empty ? "Battute esaurite" : "Saldo battute in esaurimento"}
          </p>
          <p className="text-xs text-muted-foreground mt-0.5">
            {empty
              ? "Hai terminato le battute. Abbonati o acquista un pacchetto per continuare a tradurre."
              : `Ti restano solo ${fmt(remaining)} battute. Ricarica ora per non interrompere le traduzioni.`}
          </p>
        </div>
      </div>
      <Button
        data-testid="low-balance-buy-btn"
        onClick={onBuy}
        className={`rounded-full gap-1.5 shrink-0 text-white ${empty ? "bg-destructive hover:bg-destructive/90" : "bg-brand-pink hover:bg-brand-pink/90"}`}
      >
        <Sparkles className="h-4 w-4" /> {subscribed ? "Acquista battute" : "Abbonati"}
      </Button>
    </div>
  );
}
